// extracted by mini-css-extract-plugin
export default {"showCard":"CustomRecommendationTwo_showCard__mwZLP","editStyle":"CustomRecommendationTwo_editStyle__4p+ZH","font20":"CustomRecommendationTwo_font20__8G4Ll"};